module.exports = __webpack_public_path__ + "static/img/rectangle-16.3c10297.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rectangle-16.jpg
// module id = DYWX
// module chunks = 8